<template>
  <div>
    <section class="content-header">
      <h1>
        <span>
          {{ $ml.get('shared.visitors') }}
          <i :style="connection == true ? 'color:green;' : 'color:red;'" class="fa fa-dot-circle-o"></i>
        </span>
      </h1>
      <ol class="breadcrumb">
        <li>
          <i class="fa fa-dashboard"></i>
          <span>{{ $ml.get('shared.dashboard') }}</span>
        </li>
        <li>
          <i class="fa fa-address-card"></i>
          <span>{{ $ml.get('shared.visitors') }}</span>
        </li>
        <li>
          <span>{{ $ml.get('shared.visitors') }}</span>
        </li>
      </ol>
    </section>
    <section class="content">
      <div class="row">
        <!-- LEFT MENU -->
        <div class="col-sm-4">
          <div class="nav-tabs-custom">
            <ul class="nav nav-tabs">
              <li class="active">
                <a href="#beklenenler" @click="activeTab = 1"
                  data-toggle="tab">{{ $ml.get('visitors.waitingVisitors') }}</a>
              </li>
              <li>
                <a href="#karaListe" @click="activeTab = 2" data-toggle="tab">{{ $ml.get('visitors.blackList') }}</a>
              </li>
              <li>
                <a href="#gelisNedenleri" @click="activeTab = 3"
                  data-toggle="tab">{{ $ml.get('visitors.reasonForVisit') }}</a>
              </li>
              <li class="pull-right">
                <button v-show="activeTab == 1" @click="newWaitingVisitor()" data-toggle="modal"
                  data-target="#modal-waitingVisitor" class="btn btn-sm btn-warning ">
                  <i class="fa fa-plus"></i>
                  {{ $ml.get('general.addNew') }}
                </button>
                <button v-show="activeTab == 2" @click="newBlacklistVisitor()" data-toggle="modal"
                  data-target="#modal-blacklist" class="btn btn-sm btn-warning ">
                  <i class="fa fa-plus"></i>
                  {{ $ml.get('general.addNew') }}
                </button>
                <button v-show="activeTab == 3" @click="newGelisNedeni()" data-toggle="modal"
                  data-target="#modal-gelisNedenleri" class="btn btn-sm btn-warning ">
                  <i class="fa fa-plus"></i>
                  {{ $ml.get('general.addNew') }}
                </button>
              </li>
            </ul>
            <div class="tab-content">
              <div class="tab-pane active" id="beklenenler">
                <div v-show="waitingVisitorList.length > 0" class="table-responsive no-padding"
                  :style="windowHeightSize">
                  <table class="table table-hover">
                    <thead>
                      <tr>
                        <th>{{ $ml.get('visitors.visitorName') }}</th>
                        <th>{{ $ml.get('visitors.reasonForVisit') }}</th>
                        <th>{{ $ml.get('visitors.appointmentTime') }}</th>
                        <th style="min-width:140px"></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="waitingVisitor1 in waitingVisitorList" :key="waitingVisitor1.id">
                        <td>{{ waitingVisitor1.name }}</td>
                        <td>{{ waitingVisitor1.reason }}</td>
                        <td>{{ waitingVisitor1.date | toDateFormatGet("gg.aa.yyyy ss:dd") }}</td>
                        <td class="pull-right">
                          <button data-toggle="modal" data-target="#modal-waitingVisitor" type="button" title="Düzenle"
                            @click="selectWaitingVisitor(waitingVisitor1.id, waitingVisitor1.identityNo, waitingVisitor1.name, waitingVisitor1.visitTo, waitingVisitor1.visitToSicil, waitingVisitor1.reason, waitingVisitor1.date, waitingVisitor1.description, waitingVisitor1.employeeId)"
                            class="btn btn-primary btn-sm">
                            <i class="fa fa-search"></i>
                          </button>
                          <button data-toggle="modal" data-target="#modal-hazir-kart" title="Ziyaretçi Olarak Kaydet"
                            @click="selectWaitingVisitor(waitingVisitor1.id, waitingVisitor1.identityNo, waitingVisitor1.name, waitingVisitor1.visitTo, waitingVisitor1.visitToSicil, waitingVisitor1.reason, waitingVisitor1.date, waitingVisitor1.description, waitingVisitor1.employeeId)"
                            type="button" class="btn btn-warning btn-sm">
                            <i class="fa fa-sign-out"></i>
                          </button>
                          <button data-toggle="modal" data-target="#modal-delete-waitingVisitor" title="Sil"
                            @click="editWaitingVisitor(waitingVisitor1.id, waitingVisitor1.name)" type="button"
                            class="btn btn-danger btn-sm">
                            <i class="fa fa-trash"></i>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div v-show="waitingVisitorList.length == 0" class="callout callout-info">
                  <i class="fa fa-info-circle"></i>
                  {{ $ml.get('visitors.waitingVisitorNotRecord') }}
                </div>
              </div>
              <!-- /.tab-pane -->
              <div class="tab-pane" id="karaListe">
                <div v-show="blacklistVisitorList.length > 0" class="table-responsive no-padding"
                  :style="windowHeightSize">
                  <table class="table table-hover">
                    <thead>
                      <tr>
                        <th>{{ $ml.get('visitors.blackListName') }}</th>
                        <th>{{ $ml.get('visitors.blackListDescription') }}</th>
                        <th style="min-width:140px"></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="blacklistVisitor1 in blacklistVisitorList" :key="blacklistVisitor1.id">
                        <td>{{ blacklistVisitor1.name }}</td>
                        <td>{{ blacklistVisitor1.description }}</td>
                        <td class="pull-right">
                          <button data-toggle="modal" data-target="#modal-blacklist" type="button"
                            @click="selectBlacklistVisitorDetail(blacklistVisitor1.id, blacklistVisitor1.name, blacklistVisitor1.identityNo, blacklistVisitor1.description)"
                            class="btn btn-primary btn-sm">
                            <i class="fa fa-search"></i>
                          </button>
                          <button data-toggle="modal" data-target="#modal-delete-blacklist" type="button"
                            @click="editBlacklistVisitor(blacklistVisitor1.id, blacklistVisitor1.name)"
                            class="btn btn-danger btn-sm">
                            <i class="fa fa-trash"></i>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div v-show="blacklistVisitorList.length == 0" class="callout callout-info">
                  <i class="fa fa-info-circle"></i>
                  {{ $ml.get('visitors.blackListNotRecord') }}
                </div>
              </div>
              <div class="tab-pane" id="gelisNedenleri">
                <div v-show="gelisNedeniList.length > 0" class="table-responsive no-padding" :style="windowHeightSize">
                  <table class="table table-hover">
                    <thead>
                      <tr>
                        <th>{{ $ml.get('visitors.reasonForVisit') }}</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="gelisNedeni1 in gelisNedeniList" :key="gelisNedeni1.id">
                        <td>{{ gelisNedeni1.name }}</td>
                        <td class="pull-right">
                          <button data-toggle="modal" data-target="#modal-gelisNedenleri" type="button"
                            @click="selectGelisNedeni(gelisNedeni1.id, gelisNedeni1.name)"
                            class="btn btn-primary btn-sm">
                            <i class="fa fa-search"></i>
                          </button>
                          <button data-toggle="modal" data-target="#modal-delete-reason" type="button"
                            @click="editGelisNedeni(gelisNedeni1.id, gelisNedeni1.name)" class="btn btn-danger btn-sm">
                            <i class="fa fa-trash"></i>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div v-show="gelisNedeniList.length == 0" class="callout callout-info">
                  <i class="fa fa-info-circle"></i>
                  {{ $ml.get('visitors.reasonForVisitNotRecord') }}
                </div>
              </div>
              <div class="overlay" :hidden="!isLoading">
                <i class="fa fa-refresh fa-spin"></i>
              </div>
            </div>
            <!-- /.tab-content -->
          </div>
        </div>
        <!-- VISITOR CARDS -->
        <div class="col-sm-4">
          <div class="nav-tabs-custom">
            <ul class="nav nav-tabs">
              <li class="dropdown active">
                <a class="dropdown-toggle" data-toggle="dropdown" href="#">
                  {{ selectedGroupName }}
                  <span class="caret"></span>
                </a>
                <ul class="dropdown-menu">
                  <li role="presentation" v-for="cardGroup1 in cardGroupList" :key="cardGroup1.id">
                    <a @click="getVisitorCards(cardGroup1.id, cardGroup1.name)" href="#"
                      role="menuitem">{{ cardGroup1.name }}</a>
                  </li>
                  <li role="presentation" class="divider"></li>
                  <li role="presentation">
                    <a role="menuitem" @click="getVisitorCards(0, $ml.get('general.all'))"
                      href="#">{{ $ml.get('general.all') }}</a>
                  </li>
                </ul>
              </li>
              <li class="pull-right"></li>
            </ul>
            <div class="tab-content">
              <div class="tab-pane active" id="tab_1">
                <div class="input-group" style="margin-bottom:10px;">
                  <input type="text" :placeholder="$ml.get('visitors.searchVisitorCardFromList')" v-model="searchText"
                    class="form-control" />
                  <span class="input-group-btn">
                    <button type="button" class="btn btn-primary ">
                      <i class="fa fa-search"></i>
                    </button>
                  </span>
                </div>
                <div v-show="visitorCardFilteredList.length > 0" class="table-responsive no-padding"
                  :style="windowVisitorsHeightSize">
                  <table class="table table-hover">
                    <thead>
                      <tr>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th style="min-width:90px"></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="visitorCard1 in visitorCardFilteredList" :key="visitorCard1.id">
                        <td>{{ visitorCard1.cardName }}</td>
                        <td>{{ visitorCard1.lastPerson }}</td>
                        <td class="text-center">
                          <span v-show="visitorCard1.status == 'Kullanımda'"
                            class="badge label-danger">{{ $ml.get('visitors.inUse') }}</span>
                          <span v-show="visitorCard1.status == 'Hazır'"
                            class="badge label-success">{{ $ml.get('visitors.ready') }}</span>
                          <span v-show="visitorCard1.status == 'Geçici Verildi'"
                            class="badge label-warning">{{ $ml.get('visitors.givenTemporary') }}</span>
                        </td>
                        <td class="pull-right">
                          <button v-show="visitorCard1.status == 'Kullanımda'" type="button"
                            @click="getVisitorCardDetails(visitorCard1.id)" data-toggle="modal"
                            data-target="#modal-visitor" class="btn btn-primary btn-sm">
                            <i class="fa fa-search"></i>
                          </button>
                          <button @click="exitVisitor(visitorCard1.id)"
                            v-show="visitorCard1.status == 'Kullanımda' || visitorCard1.status == 'Geçici Verildi'"
                            class="btn btn-sm btn-danger">
                            <i class="fa fa-sign-out"></i>
                          </button>
                          <button type="button" data-toggle="modal" data-target="#modal-visitor"
                            @click="selectVisitor(visitorCard1.id)" v-show="visitorCard1.status == 'Hazır'"
                            class="btn btn-sm btn-success">
                            <i class="fa fa-sign-out"></i>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div v-show="visitorCardFilteredList.length == 0" class="callout callout-info">
                  <i class="fa fa-info-circle"></i>
                  {{ $ml.get('visitors.visitorCardNotRecord') }}
                </div>
              </div>
              <!-- /.tab-pane -->
              <div class="overlay" :hidden="!isLoadingVisitor">
                <i class="fa fa-refresh fa-spin"></i>
              </div>
            </div>
            <!-- /.tab-content -->
          </div>
        </div>
        <!-- EMPLOYEES -->
        <div class="col-sm-4">
          <div class="box box-primary">
            <div class="box-header">
              <h4 class="box-title">{{ $ml.get('visitors.employeeStatus') }}</h4>
            </div>
            <div class="box-body">
              <div class="input-group" style="margin-bottom:7px;" @keyup.enter="getEmployees()">
                <input type="text" placeholder="İsim yazın ve enter tuşuna basın..." v-model="filters.nameOrCardNumber"
                  class="form-control" />
                <span class="input-group-btn">
                  <button @click="getEmployees()" type="button" class="btn btn-primary ">
                    <i class="fa fa-search"></i>
                  </button>
                </span>
              </div>
              <div v-show="employeeList.length > 0" class="table-responsive no-padding"
                :style="windowEmployeesHeightSize">
                <table class="table table-hover">
                  <tbody>
                    <tr style="cursor:pointer;" @click="getEmployeeDetail(employee1.id, 1)"
                      v-for="employee1 in employeeList" :key="employee1.id">
                      <td>{{ employee1.name }}
                        <span v-show="employee1.title">
                          ({{ employee1.title }})
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div v-show="employeeList.length == 0" class="callout callout-info">
                <i class="fa fa-info-circle"></i>
                {{ $ml.get('visitors.employeeNotRecord') }}
              </div>
              <div class="box box-widget widget-user" style="margin-top:10px;">
                <div class="widget-user-header bg-primary">
                  <h3 v-show="employee.name != ''" class="widget-user-username">{{ employee.name }}</h3>
                  <h5 v-show="employee.title != ''" class="widget-user-desc" style="font-style: italic;">
                    {{ employee.title }}</h5>
                  <h5 v-show="employee.status != '' || employee.state" class="widget-user-desc"
                    style="margin-bottom:0px;">{{ employee.status }} <span
                      :class="employee.state == 'Aktif' ? 'badge label-success' : 'badge label-danger'">{{ employee.state }}</span>
                  </h5>
                  <h5 v-show="employee.department != ''" class="widget-user-desc">{{ employee.department }}</h5>
                  <div class="widget-user-image">
                    <img class="img-circle" style="width:100px; height:100px"
                      :src="this.employee.photo == null || this.employee.photo == '' ? '/src/assets/default-user.png' : this.employee.photo" />
                  </div>
                </div>
                <div class="box-footer">
                  <ul class="nav nav-stacked">
                    <li class="align-content-center"
                      style="display: inline-flex;width: 100%;justify-content: space-between;align-items: center;">
                      <span v-show="employee.lastStatus == 1"
                        class="pull-left badge label-success">{{ $ml.get('visitors.in') }}</span>
                      <span v-show="employee.lastStatus == 2"
                        class="pull-left badge label-danger">{{ $ml.get('visitors.out') }}</span>
                      <span v-show="employee.lastStatus == null || employee.lastStatus == 0"
                        class="pull-right badge label-primary">{{ $ml.get('visitors.noLatestStatusInformation') }}</span>
                      <span class="pull-right">
                        <div class="text-right">{{ employee.lastMovementPoint }}<br />
                          <span v-show="employee.lastMovementTime != null"
                            class="text-right text-bold">{{ employee.lastMovementTime | toDateFormatGet("gg.aa.yyyy ss:dd")}}</span>

                        </div>
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="overlay" :hidden="!isLoadingEmployee">
              <i class="fa fa-refresh fa-spin"></i>
            </div>
          </div>
        </div>
      </div>
      <!--GELİŞ NEDENLERİ MODAL-->
      <div class="modal modal-primary fade" id="modal-gelisNedenleri" style="display: none;">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{ $ml.get('visitors.reasonsForVisit') }}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div class="form-group">
                <label>{{ $ml.get('visitors.reasonForVisit') }}</label>
                <input v-model="gelisNedeni.name" type="text" class="form-control" />
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-outline pull-left"
                data-dismiss="modal">{{ $ml.get('general.cancel') }}</button>
              <button type="button" @click="saveGelisNedeni()" class="btn btn-outline btn-success" data-dismiss="modal">
                <span v-show="isNewGelisNedeni">{{ $ml.get('general.save') }}</span>
                <span v-show="!isNewGelisNedeni">{{ $ml.get('general.update') }}</span>
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!--GELİŞ NEDENLERİ MODAL END-->
      <!--KARA LİSTE MODAL-->
      <div class="modal modal-primary fade" id="modal-blacklist" style="display: none;">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{ $ml.get('visitors.blackList') }}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div class="form-group">
                <label>{{ $ml.get('visitors.citizenshipNumber') }}</label>
                <input v-model="blacklistVisitor.identityNo" type="text" class="form-control" />
              </div>
              <div class="form-group">
                <label>{{ $ml.get('visitors.blackListName') }}</label>
                <input v-model="blacklistVisitor.name" type="text" class="form-control" />
              </div>
              <div class="form-group">
                <label>{{ $ml.get('visitors.blackListDescription') }}</label>
                <textarea v-model="blacklistVisitor.description" type="text" class="form-control"></textarea>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-outline pull-left"
                data-dismiss="modal">{{ $ml.get('general.cancel') }}</button>
              <button type="button" @click="saveBlacklist()" class="btn btn-outline btn-success" data-dismiss="modal">
                <span v-show="isNewBlacklist">{{ $ml.get('general.save') }}</span>
                <span v-show="!isNewBlacklist">{{ $ml.get('general.update') }}</span>
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!--KARA LİSTE MODAL END-->
      <!--ZİYARETÇİ MODAL -->
      <div class="modal modal-primary fade" id="modal-visitor" style="display: none;">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{ $ml.get('visitors.visitorInformation') }} | {{ visitorCard.cardName }} |
                  {{ visitor.entryDate }}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-sm-5">
                  <div class="box box-primary">
                    <div class="box-header">
                      <h4 class="box-title">{{ $ml.get('visitors.previousSimilarRecords') }}</h4>
                    </div>
                    <div class="box-body">
                      <div v-show="oldRecordList.length > 0" class="table-responsive no-padding"
                        style="max-height:250px; overflow:auto; color:black;">
                        <table class="table table-hover">
                          <tbody>
                            <tr v-for="oldRecord1 in oldRecordList" :key="oldRecord1.id">
                              <td>{{ oldRecord1.name }}</td>
                              <td>{{ oldRecord1.identityNo }}</td>
                              <td>
                                <button
                                  @click="getOldRecordDetail(oldRecord1.name, oldRecord1.identityNo, oldRecord1.reason, oldRecord1.toWho, oldRecord1.description, oldRecord1.mobilePhone, oldRecord1.employeeId)"
                                  class="btn btn-sm btn-primary">
                                  <i class="fa fa-search"></i>
                                </button>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div v-show="oldRecordList.length == 0" class="callout callout-info">
                        <i class="fa fa-info-circle"></i>
                        {{ $ml.get('visitors.similarRecordNotFound') }}
                      </div>
                    </div>
                    <div class="overlay" :hidden="!isLoadingVisitor">
                      <i class="fa fa-refresh fa-spin"></i>
                    </div>
                  </div>
                  <div class="box box-primary">
                    <div @keyup.enter="getEmployees()" class="box-header">
                      <h4 class="box-title">Kişi ve Departmanlar</h4>
                      <div class="pull-right box-tools">
                      </div>
                    </div>
                    <div @keyup.enter="getEmployees()" class="box-body">
                      <div class="input-group">
                        <input type="text" class="form-control" placeholder="İsim yazın ve enter tuşuna basın..."
                          v-model="searchText2" />
                        <div class="input-group-btn">
                          <button v-show="searchText2 == ''" class="btn btn-danger"
                            @click="getEmployees()">
                            <i class="fa fa-search"></i>
                          </button>
                          <button v-show="searchText2 != ''"
                            class="btn btn-danger" @click="searchText2 = ''">
                            <i class="fa fa-remove"></i>
                          </button>
                        </div>
                      </div>
                      <hr />
                      <div v-show="employeeList.length > 0 || departmentList.length > 0"
                        class="table-responsive no-padding" style="max-height:300px; overflow:auto; color:black;">
                        <table class="table table-hover">
                          <tbody>
                            <tr v-for="employee in employeeFilteredList" :key="'emp' + employee.id">
                              <td @click="getEmployeeDetail(employee.id, 2)" style="cursor:pointer;"
                                :class="visitor.employeeId == employee.id ? 'bg-success' : ''">
                                <i class="fa fa-user"></i>
                                {{ employee.name }}
                                <span v-show="employee.title">- {{ employee.title }}</span>
                              </td>
                            </tr>
                            <tr v-for="department in departmentFilteredList" :key="'dep-' + department.id">
                              <td @click="getDepartmentDetail(department.id)" style="cursor:pointer;"
                                :class="visitor.departmentId == department.id ? 'bg-success' : ''">
                                <i class="fa fa-building"></i>
                                {{ department.name }}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div v-show="employeeFilteredList.length == 0 && departmentFilteredList.length == 0"
                        class="callout callout-info">
                        <i class="fa fa-info-circle"></i>
                        {{ $ml.get('visitors.employeeNotRecord') }}
                      </div>
                    </div>
                    <div class="overlay" :hidden="!isLoadingEmployee">
                      <i class="fa fa-refresh fa-spin"></i>
                    </div>
                  </div>
                </div>
                <div class="col-sm-7">
                  <div class="row" v-show="modules.visitorTemporaryCard == true">
                    <div class="col-sm-6">
                      <button :class="visitor.isTemporaryCard == false ? 'btn btn-success active' : 'btn btn-default'"
                        @click="visitor.isTemporaryCard = false" style="width:100%;">
                        <i class="fa fa-id-card-o"></i>
                        {{ $ml.get('visitors.visitorCard') }}
                      </button>
                    </div>
                    <div class="col-sm-6">
                      <button :class="visitor.isTemporaryCard == true ? 'btn btn-success active' : 'btn btn-default'"
                        @click="visitor.isTemporaryCard = true" style="width:100%;">
                        <i class="fa fa-address-card"></i>
                        {{ $ml.get('visitors.temporaryCardForEmployee') }}
                      </button>
                    </div>
                  </div>
                  <hr v-show="modules.visitorTemporaryCard == true" />
                  <div class="row">
                    <div v-show="visitor.isTemporaryCard == false">
                      <div @keyup.enter="getOldRecords(visitor.name, visitor.identityNo)" class="form-group col-sm-6">
                        <label>{{ $ml.get('visitors.nameSurname') }}</label>
                        <input v-model="visitor.name" type="text" class="form-control" />
                      </div>
                      <div @keyup.enter="getOldRecords(visitor.name, visitor.identityNo)" class="form-group col-sm-6">
                        <label>{{ $ml.get('visitors.citizenshipNumber') }}</label>
                        <input v-model="visitor.identityNo" type="text" class="form-control" />
                      </div>
                      <div class="form-group col-sm-12">
                        <label>{{ $ml.get('visitors.reasonForVisit') }}</label>
                        <select @change="changeNeden1($event)" class="form-control">
                          <option :selected="visitor.reason == ''" value>{{ $ml.get('general.notSelected') }}</option>
                          <option v-for="neden in gelisNedeniList" :key="neden.id"
                            :selected="visitor.reason == neden.name" :value="neden.name">{{ neden.name }}</option>
                        </select>
                      </div>
                      <div class="form-group col-sm-6">
                        <label>{{ $ml.get('visitors.mobilePhone') }}</label>
                        <input v-model="visitor.mobilePhone" type="text" class="form-control" />
                      </div>
                      <div class="form-group col-sm-6">
                        <label>{{ $ml.get('visitors.where') }}</label>
                        <select @change="changeToWho($event)" class="form-control">
                          <option :selected="visitor.toWho == 'Şahıs'" value="Şahıs">{{ $ml.get('visitors.person') }}
                          </option>
                          <option :selected="visitor.toWho == 'Firma'" value="Firma">{{ $ml.get('visitors.company') }}
                          </option>
                          <option :selected="visitor.toWho == 'Diğer'" value="Diğer">{{ $ml.get('visitors.other') }}
                          </option>
                        </select>
                      </div>
                      <div class="form-group col-sm-12">
                        <label>{{ $ml.get('visitors.description') }}</label>
                        <input v-model="visitor.description" type="text" class="form-control" />
                      </div>
                      <div class="form-group col-sm-12">
                        <label>Ziyaret Edilen Departman</label>
                        <div class="input-group">
                          <label class="form-control">{{ getDepartmentName(visitor.departmentId) }}</label>
                          <div class="input-group-btn">
                            <button v-show="visitor.departmentId == null" class="btn btn-danger"
                              @click="visitor.departmentId = null">
                              <i class="fa fa-search"></i>
                            </button>
                            <button v-show="visitor.departmentId != null && visitor.departmentId != ''"
                              class="btn btn-danger" @click="visitor.departmentId = null">
                              <i class="fa fa-remove"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="form-group col-sm-12">
                      <label
                        v-show="visitor.isTemporaryCard == false">{{ $ml.get('visitors.visitedEmployeeInformation') }}</label>
                      <label
                        v-show="visitor.isTemporaryCard == true">{{ $ml.get('visitors.employeeInformation') }}</label>
                      <button v-show="visitor.employeeId" class="btn btn-danger" @click="cancelEmployee()">
                        <i class="fa fa-remove"></i>
                        {{ $ml.get('general.remove') }}
                      </button>
                      <div class="box box-widget widget-user-2">
                        <!-- Add the bg color to the header using any of the bg-* classes -->
                        <div class="widget-user-header bg-primary">
                          <div class="widget-user-image">
                            <img class="img-circle" style="width:70px; height:70px"
                              :src="this.employeeVisitor.photo == null || this.employeeVisitor.photo == '' ? '/src/assets/default-user.png' : this.employeeVisitor.photo" />
                          </div>
                          <!-- /.widget-user-image -->
                          <h3 class="widget-user-username">
                            {{ employeeVisitor.name }}
                            <span v-show="employeeVisitor.name == ''">{{ $ml.get('visitors.selectEmployee') }}</span>
                          </h3>
                          <h5 class="widget-user-desc">
                            {{ employeeVisitor.title }}
                            <span v-show="employeeVisitor.title == ''">-</span>
                          </h5>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-outline pull-left"
                data-dismiss="modal">{{ $ml.get('general.cancel') }}</button>
              <button @click="saveVisitor()" type="button" class="btn btn-outline btn-success"
                v-show="!(!isNewVisitor && visitor.isTemporaryCard == true)">
                <span v-show="isNewVisitor">{{ $ml.get('general.save') }}</span>
                <span v-show="!isNewVisitor">{{ $ml.get('general.update') }}</span>
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!--ZİYARETÇİ MODAL END -->
      <!--BEKLENENLER MODAL -->
      <div class="modal modal-primary fade" id="modal-waitingVisitor" style="display: none;">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{ $ml.get('visitors.waitingVisitorInformation') }}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-sm-5">
                  <div class="box box-primary">
                    <div @keyup.enter="getEmployees()" class="box-header">
                      <h4 class="box-title">{{ $ml.get('visitors.employeeList') }}</h4>
                      <div style="margin-top:10px;">
                        <input type="text" class="form-control" :placeholder="$ml.get('visitors.employeeSearch')"
                          v-model="filters.nameOrCardNumber" />
                      </div>
                    </div>
                    <div class="box-body">
                      <div v-show="employeeFilteredList.length > 0" class="table-responsive no-padding"
                        style="max-height:600px; overflow:auto; color:black;">
                        <table class="table table-hover">
                          <tbody>
                            <tr v-for="employee in employeeFilteredList" :key="employee.id">
                              <td>
                                {{ employee.name }}
                                <span v-show="employee.title">- {{ employee.title }}</span>
                              </td>
                              <td>
                                <button @click="getEmployeeDetail(employee.id, 3)" class="btn btn-sm btn-primary">
                                  <i class="fa fa-search"></i>
                                </button>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div v-show="employeeFilteredList.length == 0" class="callout callout-info">
                        <i class="fa fa-info-circle"></i>
                        {{ $ml.get('visitors.employeeNotRecord') }}
                      </div>
                    </div>
                    <div class="overlay" :hidden="!isLoadingEmployee">
                      <i class="fa fa-refresh fa-spin"></i>
                    </div>
                  </div>
                </div>
                <div class="col-sm-7">
                  <div class="form-group col-sm-12">
                    <label>{{ $ml.get('visitors.citizenshipNumber') }}</label>
                    <input v-model="waitingVisitor.identityNo" type="text" class="form-control" />
                  </div>
                  <div class="form-group col-sm-12">
                    <label>{{ $ml.get('visitors.nameSurname') }}</label>
                    <input v-model="waitingVisitor.name" type="text" class="form-control" />
                  </div>
                  <div class="form-group col-sm-12">
                    <label>{{ $ml.get('visitors.appointmentTime') }}</label>
                    <input v-model="waitingVisitor.date" type="datetime-local" class="form-control" />
                  </div>
                  <div class="form-group col-sm-12">
                    <label>{{ $ml.get('visitors.reasonForVisit') }}</label>
                    <select @change="changeNeden2($event)" class="form-control">
                      <option :selected="waitingVisitor.reason == ''" value>{{ $ml.get('general.notSelected') }}</option>
                      <option v-for="neden2 in gelisNedeniList" :key="neden2.id"
                        :selected="waitingVisitor.reason == neden2.name" :value="neden2.name">{{ neden2.name }}</option>
                    </select>
                  </div>
                  <div class="form-group col-sm-12">
                    <label>{{ $ml.get('visitors.description') }}</label>
                    <input v-model="waitingVisitor.description" type="text" class="form-control" />
                  </div>
                  <div class="form-group col-sm-12">
                    <label>{{ $ml.get('visitors.visitedEmployeeInformation') }}</label>
                    <div class="box box-widget widget-user-2">
                      <!-- Add the bg color to the header using any of the bg-* classes -->
                      <div class="widget-user-header bg-primary">
                        <div class="widget-user-image">
                          <img class="img-circle" style="width:70px; height:70px"
                            :src="this.employeeVisitor.photo == null || this.employeeVisitor.photo == '' ? '/src/assets/default-user.png' : this.employeeVisitor.photo" />
                        </div>
                        <!-- /.widget-user-image -->
                        <h3 class="widget-user-username">
                          {{ employeeVisitor.name }}
                          <span v-show="employeeVisitor.name == ''">{{ $ml.get('visitors.noContactInformation') }}</span>
                        </h3>
                        <h5 class="widget-user-desc">
                          {{ employeeVisitor.title }}
                          <span v-show="employeeVisitor.title == ''">-</span>
                        </h5>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-outline pull-left"
                data-dismiss="modal">{{ $ml.get('general.cancel') }}</button>
              <button @click="saveWaitingVisitor()" type="button" data-dismiss="modal"
                class="btn btn-outline btn-success">
                <span v-show="isNewWaitingVisitor">{{ $ml.get('general.save') }}</span>
                <span v-show="!isNewWaitingVisitor">{{ $ml.get('general.update') }}</span>
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!--BEKLENENLER MODAL END -->
      <!--HAZIR KART MODAL -->
      <div class="modal modal-primary fade" id="modal-hazir-kart" style="display: none;">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{ $ml.get('visitors.selectVisitorCardToGive') }}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-sm-12">
                  <div class="box box-primary">
                    <div class="box-header">
                      <h4 class="box-title">{{ $ml.get('visitors.visitorCards') }}</h4>
                    </div>
                    <div class="box-body">
                      <div v-show="hazirCardFilteredList.length > 0" class="table-responsive no-padding"
                        style="max-height:300px; overflow:auto; color:black;">
                        <table class="table table-hover">
                          <tbody>
                            <tr v-for="visitorCard1 in hazirCardFilteredList" :key="visitorCard1.id">
                              <td>{{ visitorCard1.cardName }}</td>
                              <td>{{ visitorCard1.lastPerson }}</td>
                              <td class="text-center">
                                <span v-show="visitorCard1.status == 'Kullanımda'"
                                  class="badge label-danger">{{ $ml.get('visitors.inUse') }}</span>
                                <span v-show="visitorCard1.status == 'Hazır'"
                                  class="badge label-success">{{ $ml.get('visitors.ready') }}</span>
                              </td>
                              <td class="pull-right">
                                <button type="button" data-dismiss="modal"
                                  @click="saveWaitingVisitorToCard(visitorCard1.id)" class="btn btn-primary btn-sm">
                                  <i class="fa fa-check"></i>
                                  {{ $ml.get('general.select2') }}
                                </button>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div v-show="hazirCardFilteredList.length == 0" class="callout callout-info">
                        <i class="fa fa-info-circle"></i>
                        {{ $ml.get('visitors.readyToUseVisitorCardNotRecord') }}
                      </div>
                    </div>
                    <div class="overlay" :hidden="!isLoading">
                      <i class="fa fa-refresh fa-spin"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-outline pull-left"
                data-dismiss="modal">{{ $ml.get('general.cancel') }}</button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!--HAZIR KART MODAL END -->
      <!-- BEKLENENLER SİL START-->
      <div class="modal modal-danger fade" id="modal-delete-waitingVisitor">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{ $ml.get('general.delete') }}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div>
                <span>{{ selectedWaitingVisitorName }}</span>
              </div>
              <br />
              <p></p>
              <span>{{ $ml.get('visitors.isContinueDeleteWaitingVisitor') }}</span>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger" data-dismiss="modal">
                <i class="fa fa-remove"></i>
                <span>{{ $ml.get('general.cancel') }}</span>
              </button>
              <button @click="deleteWaitingVisitor(selectedWaitingVisitorId)" class="btn btn-danger"
                data-dismiss="modal">
                <i class="fa fa-trash"></i>
                <span>{{ $ml.get('general.delete') }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- /.MODAL END -->
      <!-- KARA LİSTE SİL START-->
      <div class="modal modal-danger fade" id="modal-delete-blacklist">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{ $ml.get('general.delete') }}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div>
                <span>{{ selectedBlackListName }}</span>
              </div>
              <br />
              <p></p>
              <span>{{ $ml.get('visitors.isContinueDeleteBlackList') }}</span>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger" data-dismiss="modal">
                <i class="fa fa-remove"></i>
                <span>{{ $ml.get('general.cancel') }}</span>
              </button>
              <button @click="deleteBlacklistVisitor(selectedBlackListId)" class="btn btn-danger" data-dismiss="modal">
                <i class="fa fa-trash"></i>
                <span>{{ $ml.get('general.delete') }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- /.MODAL END -->
      <!-- GELİŞ NEDENİ SİL START-->
      <div class="modal modal-danger fade" id="modal-delete-reason">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{ $ml.get('general.delete') }}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div>
                <span>{{ selectedReasonName }}</span>
              </div>
              <br />
              <p></p>
              <span>{{ $ml.get('visitors.isContinueDeleteReason') }}</span>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger" data-dismiss="modal">
                <i class="fa fa-remove"></i>
                <span>{{ $ml.get('general.cancel') }}</span>
              </button>
              <button @click="deleteGelisNedeni(selectedReasonId)" class="btn btn-danger" data-dismiss="modal">
                <i class="fa fa-trash"></i>
                <span>{{ $ml.get('general.delete') }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- /.MODAL END -->
    </section>
  </div>
</template>

<script>
import {
  HubConnectionBuilder,
  LogLevel,
  HubConnection
} from "@microsoft/signalr";
export default {
  data() {
    return {
      windowHeight: window.innerHeight,
      connection: false,
      waitingVisitor: {
        id: null,
        identityNo: "",
        name: "",
        visitTo: "",
        visitToSicil: "",
        reason: "",
        date: null,
        description: "",
        employeeId: null
      },
      blacklistVisitor: {
        id: null,
        identityNo: "",
        name: "",
        description: ""
      },
      gelisNedeni: {
        id: null,
        name: ""
      },
      visitor: {
        id: null,
        name: "",
        identityNo: "",
        employeeId: "",
        departmentId: null,
        visitTo: "",
        visitToSicil: "",
        reason: "",
        entryDate: "",
        toWho: "",
        description: "",
        mobilePhone: "",
        isTemporaryCard: false
      },
      visitorCard: {
        id: null,
        cardName: "",
        status: "",
        terminalNo: "",
        cardNo: "",
        accessDoor: "",
        lastPerson: ""
      },
      employee: {
        photo: null,
        name: "",
        lastStatus: null,
        lastMovementTime: null,
        lastMovementPoint: "",
        title: "",
        department: "",
        state: "",
        status: ""
      },
      employeeVisitor: {
        id: null,
        sicilNo: "",
        photo: null,
        name: "",
        lastStatus: null,
        lastMovementPoint: "",
        title: "",
        department: ""
      },
      selectedWaitingVisitorId: "",
      selectedWaitingVisitorName: "",
      selectedBlackListId: "",
      selectedBlackListName: "",
      selectedReasonId: "",
      selectedReasonName: "",
      type: 1,
      activeTab: 1,
      isNewVisitor: true,
      isNewBlacklist: true,
      isNewWaitingVisitor: true,
      isNewGelisNedeni: true,
      employeeSearchText: "",
      searchText: "",
      searchText2: "",
      oldRecords: [],
      cardGroups: [],
      employees: [],
      visitorCards: [],
      waitingVisitors: [],
      blacklistVisitors: [],
      gelisNedenleri: [],
      departments: [],
      selectedGroupName: this.$ml.get("visitors.selectVisitorCardGroup"),
      selectedGroupId: null,
      isLoading: false,
      isLoadingEmployee: false,
      isLoadingVisitor: false,
      filters: {
        nameOrCardNumber: "",
        sicilOrTerminalNo: null,
        departments: [],
        accessGroup: [],
        identityNo: "",
        documentNoOrMail: "",
        foodGroup: [],
        workGroupId: [],
        title: "",
        stateId: [],
        statuId: [],
        plateNo: "",
        extraField1key: 0,
        extraField1value: "",
        extraField2key: 0,
        extraField2value: "",
        extraField3key: 0,
        extraField3value: "",
        extraField4key: 0,
        extraField4value: "",
        isVisitor: false,
        isActive: true
      },
    };
  },
  filters: {
    toDateFormatGet(str, format) {
      if (!str) {
        return "";
      }
      if (format == "gg.aa.yyyy ss:dd") {
        str = new Date(str);
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika =
          str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        return gun + "." + ay + "." + yil + " " + saat + ":" + dakika;
      } else if (format == "gg.aa.yyyy") {
        str = new Date(str);
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        return gun + "." + ay + "." + yil;
      } else if (format == "ss:dd:ss") {
        str = new Date("1900-01-01 " + str.replace("Z", ""));
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika =
          str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        var saniye =
          str.getSeconds() < 10 ? "0" + str.getSeconds() : str.getSeconds();
        return saat + ":" + dakika + ":" + saniye;
      } else if (format == "ss:dd") {
        str = new Date("1900-01-01 " + str.replace("Z", ""));
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika =
          str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        return saat + ":" + dakika;
      }
    }
  },
  computed: {
    modules() {
      return this.$store.getters.getModules;
    },
    conStatus() {
      return this.connection;
    },
    waitingVisitorList() {
      return this.waitingVisitors;
    },
    blacklistVisitorList() {
      return this.blacklistVisitors;
    },
    gelisNedeniList() {
      return this.gelisNedenleri;
    },
    visitorCardList() {
      return this.visitorCards.sort((a, b) => {
        if (a.cardName < b.cardName) return -1;
        if (a.cardName > b.cardName) return 0;
      });
    },
    employeeList() {
      return this.employees;
    },
    cardGroupList() {
      return this.cardGroups;
    },
    changeIsTemporaryCard() {
      return this.visitor.isTemporaryCard;
    },
    oldRecordList() {
      return this.oldRecords;
    },
    allEmployeeFilteredList() {
      if (this.employeeSearchText != "") {
        if ($.isNumeric(this.employeeSearchText) == false) {
          return this.employeeList.filter(item => {
            return this.employeeSearchText
              .toUpperCase()
              .split(" ")
              .every(v => item.name.toUpperCase().includes(v));
          });
        } else {
          return this.employeeList.filter(item => {
            return this.employeeSearchText
              .split(" ")
              .every(v => item.name.includes(v));
          });
        }
      } else {
        return this.employeeList.sort((a, b) => {
          if (a.name.toUpperCase() < b.name.toUpperCase()) return -1;
          if (a.name.toUpperCase() > b.name.toUpperCase()) return 0;
        });
      }
    },
    employeeFilteredList() {
      if (this.searchText2 != "") {
        if ($.isNumeric(this.searchText2) == false) {
          return this.employeeList.filter(item => {
            return this.searchText2
              .toUpperCase()
              .split(" ")
              .every(v => item.name.toUpperCase().includes(v));
          });
        } else {
          return this.employeeList.filter(item => {
            return this.searchText2
              .split(" ")
              .every(v => item.name.includes(v));
          });
        }
      } else {
        return this.employeeList;
      }
    },
    departmentList() {
      return this.departments;
    },
    departmentFilteredList() {
      if (this.searchText2 != "") {
        if ($.isNumeric(this.searchText2) == false) {
          return this.departmentList.filter(item => {
            return this.searchText2
              .toUpperCase()
              .split(" ")
              .every(v => item.name.toUpperCase().includes(v));
          });
        } else {
          return this.departmentList.filter(item => {
            return this.searchText2
              .split(" ")
              .every(v => item.name.includes(v));
          });
        }
      } else {
        return this.departmentList;
      }
    },
    visitorCardFilteredList() {
      if (this.searchText) {
        if ($.isNumeric(this.searchText) == false) {
          return this.visitorCardList.filter(item => {
            return this.searchText
              .toUpperCase()
              .split(" ")
              .every(
                v =>
                  item.cardName.toUpperCase().includes(v) ||
                  item.lastPerson.toUpperCase().includes(v)
              );
          });
        } else {
          return this.visitorCardList.filter(item => {
            return this.searchText
              .split(" ")
              .every(
                v => item.cardName.includes(v) || item.lastPerson.includes(v)
              );
          });
        }
      } else {
        return this.visitorCardList;
      }
    },
    hazirCardFilteredList() {
      let hazir = "Hazır";
      return this.visitorCardList.filter(item => {
        return hazir
          .toUpperCase()
          .split(" ")
          .every(v => item.status.toUpperCase().includes(v));
      });
    },
    windowHeightSize() {
      if (this.windowHeight) {
        let height = this.windowHeight - 260;
        return "max-height:" + height + "px;overflow:auto;";
      } else {
        return "max-height:370px;overflow:auto;";
      }
    },
    windowVisitorsHeightSize() {
      if (this.windowHeight) {
        let height = this.windowHeight - 310;
        return "max-height:" + height + "px;overflow:auto;";
      } else {
        return "max-height:370px;overflow:auto;";
      }
    },
    windowEmployeesHeightSize() {
      if (this.windowHeight) {
        let height = this.windowHeight - 520;
        return "max-height:" + height + "px;overflow:auto;";
      } else {
        return "max-height:370px;overflow:auto;";
      }
    },
    baseURL() {
      return this.$store.getters.getBaseURL;
    }
  },
  watch: {
    windowHeight(newHeight, oldHeight) {
      if (newHeight < 576) {
        //MOBİL
      } else {
        //WEB
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
    var hubConnection = new HubConnectionBuilder()
      .withUrl(this.baseURL + "/VisitorMonitor")
      .withAutomaticReconnect()
      .build();
    // connecting to the hub
    hubConnection
      .start()
      .then(() => {
        console.log("connection started");
        this.connection = true;
      })
      .catch(err => {
        console.log("connecting hub failed err is : ", err);
        this.connection = false;
      });

    //at the hub there is a function named broadcastMessage, should return string that will be added to an array. should it be at sotr's getter
    hubConnection.on("VisitorUpdated", result => {
      if (result == true) {
        //Kartları Güncelle
        if (this.selectedGroupId != null) {
          this.getVisitorCards(this.selectedGroupId, this.selectedGroupName);
        } else {
          this.getVisitorCards(0, this.$ml.get("general.all"));
        }
      }
    });

    hubConnection.onclose(() => {
      console.log("connection failed");
      this.connection = false;
    });
  },
  methods: {
    onResize() {
      this.windowHeight = window.innerHeight;
    },
    changeToWho(event) {
      this.visitor.toWho = event.target.value;
    },
    changeNeden1(event) {
      this.visitor.reason = event.target.value;
    },
    changeNeden2(event) {
      this.waitingVisitor.reason = event.target.value;
    },
    async getVisitorFromId(id) {
      let aList = this.visitorCards;
      let visitorCard = await aList.filter(function (item) {
        return item.id == id;
      });
      if (visitorCard != "" && visitorCard != null) {
        return visitorCard[0];
      } else {
        return null;
      }
    },
    async getCardGroupNameFromId(id) {
      let aList = this.cardGroups;
      let visitorCardGroup = await aList.filter(function (item) {
        return item.id == id;
      });
      if (visitorCardGroup != "" && visitorCardGroup != null) {
        return visitorCardGroup[0].name;
      } else {
        return null;
      }
    },
    filtersClear() {
      this.filters.nameOrCardNumber = "";
      this.filters.sicilOrTerminalNo = null;
      this.filters.departments = [];
      this.filters.accessGroup = null;
      this.filters.identityNo = "";
      this.filters.documentNoOrMail = "";
      this.filters.foodGroup = null;
      this.filters.workGroupId = null;
      this.filters.title = "";
      this.filters.stateId = null;
      this.filters.statuId = null;
      this.filters.plateNo = "";
      this.filters.extraField1key = 0;
      this.filters.extraField1value = "";
      this.filters.extraField2key = 0;
      this.filters.extraField2value = "";
      this.filters.extraField3key = 0;
      this.filters.extraField3value = "";
      this.filters.extraField4key = 0;
      this.filters.extraField4value = "";
      this.filters.isVisitor = false;
      this.filters.isActive = true;
    },
    async getEmployees() {
      if (this.searchText2 != null && this.searchText2 != "") {
        this.filters.nameOrCardNumber = this.searchText2;
      }
      if (this.filters.nameOrCardNumber == "") {
        alertify.warning("Lütfen arama kısmını boş bırakmayın...");
        return;
      }
      try {
        this.isLoadingEmployee = true;
        var employees = [];
        let filters2 = this.filters;
        const response = await this.$axios
          .post("/Employees/getByFilter", {
            nameOrCardNumber: filters2.nameOrCardNumber,
            sicilOrTerminalNo: filters2.sicilOrTerminalNo,
            departments: filters2.departments,
            accessGroup: filters2.accessGroup,
            identityNo: filters2.identityNo,
            documentNoOrMail: filters2.documentNoOrMail,
            foodGroup: filters2.foodGroup,
            workGroupId: filters2.workGroupId,
            title: filters2.title,
            stateId: filters2.stateId,
            statuId: filters2.statuId,
            plateNo: filters2.plateNo,
            extraField1key: filters2.extraField1key,
            extraField1value: filters2.extraField1value,
            extraField2key: filters2.extraField2key,
            extraField2value: filters2.extraField2value,
            extraField3key: filters2.extraField3key,
            extraField3value: filters2.extraField3value,
            extraField4key: filters2.extraField4key,
            extraField4value: filters2.extraField4value,
            isVisitor: filters2.isVisitor,
            isActive: filters2.isActive
          })
          .then(response => {
            employees = response.data;
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              } else if (error.response.status == 403) {
                alertify.message(
                  this.$ml.get("alerts.userIsNotAuthorizedToSeeData")
                );
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoadingEmployee = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoadingEmployee = false;
                return;
              }
            }
          });
        this.employees = employees;
        this.isLoadingEmployee = false;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
        this.isLoadingEmployee = false;
      }
    },
    newBlacklistVisitor() {
      this.isNewBlacklist = true;
      this.blacklistVisitor.id = null;
      this.blacklistVisitor.identityNo = "";
      this.blacklistVisitor.name = "";
      this.blacklistVisitor.description = "";
      this.selectedBlackListId = "";
      this.selectedBlackListName = "";
    },
    selectBlacklistVisitorDetail(id, name, identityNo, description) {
      this.isNewBlacklist = false;
      this.blacklistVisitor.id = id;
      this.blacklistVisitor.identityNo = identityNo;
      this.blacklistVisitor.name = name;
      this.blacklistVisitor.description = description;
    },
    editBlacklistVisitor(id, name) {
      this.selectedBlackListId = id;
      this.selectedBlackListName = name;
    },
    newWaitingVisitor() {
      this.isNewWaitingVisitor = true;
      this.waitingVisitor.id = null;
      this.waitingVisitor.identityNo = "";
      this.waitingVisitor.name = "";
      this.waitingVisitor.employeeId = null;
      this.waitingVisitor.visitTo = "";
      this.waitingVisitor.visitToSicil = "";
      this.waitingVisitor.reason = "";
      this.waitingVisitor.date = "";
      this.waitingVisitor.description = "";
      this.searchText2 = "";
      this.employeeVisitor.id = null;
      this.employeeVisitor.photo = null;
      this.employeeVisitor.sicilNo = "";
      this.employeeVisitor.name = "";
      this.employeeVisitor.lastStatus = null;
      this.employeeVisitor.lastMovementPoint = "";
      this.employeeVisitor.title = "";
      this.employeeVisitor.department = "";
      (this.selectedWaitingVisitorId = ""),
        (this.selectedWaitingVisitorName = "");
    },
    editWaitingVisitor(id, name) {
      this.selectedWaitingVisitorId = id;
      this.selectedWaitingVisitorName = name;
    },
    selectWaitingVisitor(
      id,
      identityNo,
      name,
      visitTo,
      visitToSicil,
      reason,
      date,
      description,
      employeeId
    ) {
      this.isNewWaitingVisitor = false;
      this.waitingVisitor.id = id;
      this.waitingVisitor.identityNo = identityNo;
      this.waitingVisitor.name = name;
      this.waitingVisitor.visitTo = visitTo;
      this.waitingVisitor.visitToSicil = visitToSicil;
      this.waitingVisitor.reason = reason;
      this.waitingVisitor.date = date;
      this.waitingVisitor.description = description;
      this.waitingVisitor.employeeId = employeeId;
      this.getEmployeeDetail(employeeId, 3);
    },
    async deleteWaitingVisitor(id) {
      try {
        this.isLoading = true;
        if (id != null) {
          const response = await this.$axios
            .delete("/Visitors/DeleteWaitingVisitor/" + id)
            .then(response => {
              this.getWaitingVisitors();
              this.newWaitingVisitor();
              alertify.success(this.$ml.get("alerts.deletedSuccessfully"));
            })
            .catch(doc => {
              if (doc.status == 401) {
                this.$store.dispatch("logout");
              } else if (doc.message == "Network Error") {
                alertify.error(this.$ml.get("errors.connectionError"));
              } else {
                alertify.error(doc.message);
              }
            });
        }
        this.isLoading = false;
      } catch (error) {
        alertify.error("Hata Oluştu : " + error);
        this.isLoading = false;
      }
    },
    async deleteBlacklistVisitor(id) {
      try {
        this.isLoading = true;
        if (id != null) {
          const response = await this.$axios
            .delete("/Visitors/DeleteBlackList/" + id)
            .then(response => {
              this.getBlacklistVisitors();
              this.newBlacklistVisitor();
              alertify.success(this.$ml.get("alerts.deletedSuccessfully"));
            })
            .catch(doc => {
              if (doc.status == 401) {
                this.$store.dispatch("logout");
              } else if (doc.message == "Network Error") {
                alertify.error(this.$ml.get("errors.connectionError"));
              } else {
                alertify.error(doc.message);
              }
            });
        }
        this.isLoading = false;
      } catch (error) {
        alertify.error("Hata Oluştu : " + error);
        this.isLoading = false;
      }
    },
    newGelisNedeni() {
      this.isNewGelisNedeni = true;
      this.gelisNedeni.id = null;
      this.gelisNedeni.name = "";
      this.selectedReasonId = "";
      this.selectedReasonName = "";
    },
    selectGelisNedeni(id, name) {
      this.isNewGelisNedeni = false;
      this.gelisNedeni.id = id;
      this.gelisNedeni.name = name;
    },
    editGelisNedeni(id, name) {
      this.selectedReasonId = id;
      this.selectedReasonName = name;
    },
    async deleteGelisNedeni(id) {
      try {
        this.isLoading = true;
        if (id != null) {
          const response = await this.$axios
            .delete("/Visitors/DeleteReason/" + id)
            .then(response => {
              this.getGelisNedenleri();
              this.newGelisNedeni();
              alertify.success(this.$ml.get("alerts.deletedSuccessfully"));
            })
            .catch(doc => {
              if (doc.status == 401) {
                this.$store.dispatch("logout");
              } else if (doc.message == "Network Error") {
                alertify.error(this.$ml.get("errors.connectionError"));
              } else {
                alertify.error(doc.message);
              }
            });
        }
        this.isLoading = false;
      } catch (error) {
        alertify.error("Hata Oluştu : " + error);
        this.isLoading = false;
      }
    },
    async saveGelisNedeni() {
      this.isLoading = true;
      if (this.isNewGelisNedeni) {
        try {
          let gelisNedeni = this.gelisNedeni;
          const response = await this.$axios
            .post("/Visitors/AddReason", {
              name: gelisNedeni.name
            })
            .then(response => {
              if (response.status == 200) {
                alertify.success(this.$ml.get("alerts.savedSuccessfully"));
              } else {
                alertify.error(response.message);
              }
              let id = response.data.id;
              this.getGelisNedenleri();
              this.newGelisNedeni();
            })
            .catch(doc => {
              if (doc.status == 401) {
                this.$store.dispatch("logout");
              } else if (doc.message == "Network Error") {
                alertify.error(this.$ml.get("errors.connectionError"));
              } else {
                alertify.error(doc.message);
              }
            });
          this.isLoading = false;
        } catch (error) {
          console.error(error);
          alertify.error(error.message);
          this.isLoading = false;
        }
      } else {
        //GÜNCELLE
        try {
          let gelisNedeni = this.gelisNedeni;
          const response = await this.$axios
            .post("/Visitors/UpdateReason/" + gelisNedeni.id, {
              id: gelisNedeni.id,
              name: gelisNedeni.name
            })
            .then(response => {
              if (response.status == 200) {
                alertify.success(this.$ml.get("alerts.updatedSuccessfully"));
              } else {
                alertify.error(response.message);
              }
              this.getGelisNedenleri();
              this.newGelisNedeni();
            })
            .catch(doc => {
              if (doc.status == 401) {
                this.$store.dispatch("logout");
              } else if (doc.message == "Network Error") {
                alertify.error(this.$ml.get("errors.connectionError"));
              } else {
                alertify.error(doc.message);
              }
            });
          this.isLoading = false;
        } catch (error) {
          console.error(error);
          alertify.error(error);
          this.isLoading = false;
        }
      }
    },
    async saveWaitingVisitorToCard(cardId) {
      try {
        this.isLoading = true;
        let waitingVisitor = this.waitingVisitor;
        const response = await this.$axios
          .post(
            "/Visitors/SaveWaitingVisitor?visitorId=" +
            waitingVisitor.id +
            "&cardId=" +
            cardId
          )
          .then(response => {
            if (response.status == 200) {
              alertify.success(this.$ml.get("alerts.savedSuccessfully"));
              this.getWaitingVisitors();
              this.getVisitorCards(
                this.selectedGroupId,
                this.selectedGroupName
              );
            }
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.isLoading = false;
      } catch (error) {
        console.error(error);
        alertify.error("Hata :" + error.message);
        this.isLoading = false;
      }
    },
    async saveBlacklist() {
      this.isLoading = true;
      if (this.isNewBlacklist) {
        try {
          let blacklist = this.blacklistVisitor;
          const response = await this.$axios
            .post("/Visitors/AddBlackList", {
              name: blacklist.name,
              identityNo: blacklist.identityNo,
              description: blacklist.description
            })
            .then(response => {
              if (response.status == 200) {
                alertify.success(this.$ml.get("alerts.savedSuccessfully"));
              } else {
                alertify.error(response.message);
              }
              let id = response.data.id;
              this.getBlacklistVisitors();
              this.newBlacklistVisitor();
            })
            .catch(doc => {
              if (doc.status == 401) {
                this.$store.dispatch("logout");
              } else if (doc.message == "Network Error") {
                alertify.error(this.$ml.get("errors.connectionError"));
              } else {
                alertify.error(doc.message);
              }
            });
          this.isLoading = false;
        } catch (error) {
          console.error(error);
          alertify.error(error.message);
          this.isLoading = false;
        }
      } else {
        //GÜNCELLE
        try {
          let blacklist = this.blacklistVisitor;
          const response = await this.$axios
            .post("/Visitors/UpdateBlackList/" + blacklist.id, {
              id: blacklist.id,
              identityNo: blacklist.identityNo,
              name: blacklist.name,
              description: blacklist.description
            })
            .then(response => {
              if (response.status == 200) {
                alertify.success(this.$ml.get("alerts.updatedSuccessfully"));
              } else {
                alertify.error(response.message);
              }
              this.getBlacklistVisitors();
              this.newBlacklistVisitor();
            })
            .catch(doc => {
              if (doc.status == 401) {
                this.$store.dispatch("logout");
              } else if (doc.message == "Network Error") {
                alertify.error(this.$ml.get("errors.connectionError"));
              } else {
                alertify.error(doc.message);
              }
            });
          this.isLoading = false;
        } catch (error) {
          console.error(error);
          alertify.error(error);
          this.isLoading = false;
        }
      }
    },
    async saveWaitingVisitor() {
      if (this.waitingVisitor.identityNo == "") {
        alertify.warning(this.$ml.get("alerts.visitorIdentityNumberNotBlank"));
        return;
      }
      if (this.waitingVisitor.name == "") {
        alertify.warning(this.$ml.get("alerts.visitorNameNotBlank"));
        return;
      }
      this.isLoading = true;
      if (this.isNewWaitingVisitor) {
        try {
          let waitingVisitor = this.waitingVisitor;
          const response = await this.$axios
            .post("/Visitors/AddWaitingVisitor", {
              identityNo: waitingVisitor.identityNo,
              name: waitingVisitor.name,
              visitTo: waitingVisitor.visitTo,
              visitToSicil: waitingVisitor.visitToSicil,
              reason: waitingVisitor.reason,
              date: waitingVisitor.date,
              description: waitingVisitor.description,
              employeeId: waitingVisitor.employeeId
            })
            .then(response => {
              if (response.status == 200) {
                alertify.success(this.$ml.get("alerts.savedSuccessfully"));
              } else {
                alertify.error(response.message);
              }
              let id = response.data.id;
              this.getWaitingVisitors();
              this.newWaitingVisitor();
            })
            .catch(doc => {
              if (doc.status == 401) {
                this.$store.dispatch("logout");
              } else if (doc.message == "Network Error") {
                alertify.error(this.$ml.get("errors.connectionError"));
              } else {
                alertify.error(doc.message);
              }
            });
          this.isLoading = false;
        } catch (error) {
          console.error(error);
          alertify.error(error.message);
          this.isLoading = false;
        }
      } else {
        //GÜNCELLE
        try {
          let waitingVisitor = this.waitingVisitor;
          const response = await this.$axios
            .post("/Visitors/UpdateWaitingVisitor/" + waitingVisitor.id, {
              identityNo: waitingVisitor.identityNo,
              name: waitingVisitor.name,
              visitTo: waitingVisitor.visitTo,
              visitToSicil: waitingVisitor.visitToSicil,
              reason: waitingVisitor.reason,
              date: waitingVisitor.date,
              description: waitingVisitor.description,
              employeeId: waitingVisitor.employeeId
            })
            .then(response => {
              if (response.status == 200) {
                alertify.success(this.$ml.get("alerts.updatedSuccessfully"));
              } else {
                alertify.error(response.message);
              }
              this.getWaitingVisitors();
              this.newWaitingVisitor();
            })
            .catch(doc => {
              if (doc.status == 401) {
                this.$store.dispatch("logout");
              } else if (doc.message == "Network Error") {
                alertify.error(this.$ml.get("errors.connectionError"));
              } else {
                alertify.error(doc.message);
              }
            });
          this.isLoading = false;
        } catch (error) {
          console.error(error);
          alertify.error(error);
          this.isLoading = false;
        }
      }
    },
    async saveVisitor() {
      if (this.visitor.isTemporaryCard == false) {
        if (this.visitor.identityNo == "") {
          alertify.warning(
            this.$ml.get("alerts.visitorIdentityNumberNotBlank")
          );
          return;
        }
        if (this.visitor.name == "") {
          alertify.warning(this.$ml.get("alerts.visitorNameNotBlank"));
          return;
        }
      }
      this.isLoadingVisitor = true;
      if (this.isNewVisitor) {
        try {
          let visitor = this.visitor;
          let visitorCard = this.visitorCard;
          let employeeVisitor = this.employeeVisitor;
          const response = await this.$axios
            .post("/Visitors/AddVisitor", {
              name: visitor.name,
              visitTo: employeeVisitor.name,
              visitToSicil: employeeVisitor.sicilNo,
              reason: visitor.reason,
              description: visitor.description,
              departmentId: visitor.departmentId,
              identityNo: visitor.identityNo,
              toWho: visitor.toWho,
              cardId: visitorCard.id,
              mobilePhone: visitor.mobilePhone,
              isTemporaryCard: visitor.isTemporaryCard
            })
            .then(response => {
              if (response.status == 200) {
                alertify.success(this.$ml.get("alerts.savedSuccessfully"));
                $("#modal-visitor").modal("hide");
              } else if (response.status == 201) {
                alertify.error(
                  this.$ml.get("alerts.attentionPersonIsInBlackList")
                );
              } else if (response.status == 202) {
                alertify.error(this.$ml.get("alerts.cardIsUsed"));
                if (this.connection == false) {
                  alertify.error(
                    this.$ml.get("alerts.unableToConnectPageRefreshing")
                  );
                  router.replace("/dashboard");
                }
              } else {
                alertify.error(response.message);
              }
              let id = response.data.id;
              this.getVisitorCards(
                this.selectedGroupId,
                this.selectedGroupName
              );
              this.newVisitor();
            })
            .catch(doc => {
              if (doc.status == 401) {
                this.$store.dispatch("logout");
              } else if (doc.message == "Network Error") {
                alertify.error(this.$ml.get("errors.connectionError"));
              } else {
                alertify.error(doc.message);
              }
            });
          this.isLoadingVisitor = false;
        } catch (error) {
          console.error(error);
          alertify.error(error.message);
          this.isLoadingVisitor = false;
        }
      } else {
        //GÜNCELLE
        try {
          let visitor = this.visitor;
          let visitorCard = this.visitorCard;
          let employeeVisitor = this.employeeVisitor;
          const response = await this.$axios
            .post("/Visitors/UpdateVisitor/" + visitor.id, {
              name: visitor.name,
              visitTo: employeeVisitor.name,
              visitToSicil: employeeVisitor.sicilNo,
              reason: visitor.reason,
              description: visitor.description,
              employeeId: visitor.employeeId,
              departmentId: visitor.departmentId,
              identityNo: visitor.identityNo,
              toWho: visitor.toWho,
              cardId: visitorCard.id,
              mobilePhone: visitor.mobilePhone,
              isTemporaryCard: visitor.isTemporaryCard
            })
            .then(response => {
              if (response.status == 200) {
                $("#modal-visitor").modal("hide");
                alertify.success(this.$ml.get("alerts.savedSuccessfully"));
              } else if (response.status == 201) {
                alertify.error(
                  this.$ml.get(
                    "alerts.attentionPersonIsInBlackListNotBeenUpdated"
                  )
                );
              } else {
                alertify.error(response.message);
              }
              this.getVisitorCards(
                this.selectedGroupId,
                this.selectedGroupName
              );
              this.newVisitor();
            })
            .catch(doc => {
              if (doc.status == 401) {
                this.$store.dispatch("logout");
              } else if (doc.message == "Network Error") {
                alertify.error(this.$ml.get("errors.connectionError"));
              } else {
                alertify.error(doc.message);
              }
            });
          this.isLoadingVisitor = false;
        } catch (error) {
          console.error(error);
          alertify.error(error);
          this.isLoadingVisitor = false;
        }
      }
    },
    getOldRecordDetail(
      name,
      identityNo,
      reason,
      toWho,
      description,
      mobilePhone,
      employeeId
    ) {
      this.visitor.name = name;
      this.visitor.identityNo = identityNo;
      this.visitor.reason = reason;
      this.visitor.toWho = toWho;
      this.visitor.description = description;
      this.visitor.mobilePhone = mobilePhone;
      this.visitor.employeeId = employeeId;
      this.visitor.departmentId = departmentId;
      this.getEmployeeDetail(employeeId, 2);
    },
    async isBlackList(name, identityNo) {
      var data = null;
      if (name != "" && identityNo != "") {
        this.blacklistVisitorList.filter(item => {
          return item.name == name && item.name;
        });
      } else if (name != "" && identityNo == "") {
      } else if (name == "" && identityNo != "") {
      } else {
        return false;
        $("#modal-visitor").modal("hide");
      }
    },
    async getOldRecords(name, identityNo) {
      if (name != "" || identityNo != "") {
        this.isLoadingVisitor = true;
        try {
          let oldRecords = [];
          var searchText5 = "?";
          if (name.length > 4) {
            searchText5 = searchText5 + "name=" + name;
          }
          if (identityNo.length > 4) {
            if (searchText5 != "?") {
              searchText5 = searchText5 + "&";
            }
            searchText5 = searchText5 + "identityNo=" + identityNo;
          }
          const response = await this.$axios
            .get("/Visitors/SearchOldRecords" + searchText5)
            .then(response => {
              if (response.status == 200) {
                response.data.forEach(doc => {
                  oldRecords.push({
                    name: doc.name,
                    identityNo: doc.identityNo,
                    visitTo: doc.visitTo,
                    visitToSicil: doc.visitToSicil,
                    reason: doc.reason,
                    toWho: doc.toWho,
                    description: doc.description,
                    mobilePhone: doc.mobilePhone,
                    employeeId: doc.employeeId
                  });
                });
              }
              this.oldRecords = oldRecords;
            })
            .catch(error => {
              if (error.response) {
                if (error.response.status == 401) {
                  this.$store.dispatch("logout");
                }
                if (error.response.status == 204) {
                }
              } else {
                if (
                  error.message == "Network Error" ||
                  error.message == "Error: Network Error"
                ) {
                  alertify.error(this.$ml.get("errors.connectionError"));
                  this.isLoadingVisitor = false;
                  return;
                } else {
                  console.error(error);
                  alertify.error(error.message);
                  this.isLoadingVisitor = false;
                  return;
                }
              }
            });
          this.isLoadingVisitor = false;
        } catch (error) {
          console.error(error);
          alertify.error("Hata :" + error.message);
          this.isLoadingVisitor = false;
        }
      } else {
        this.oldRecords = [];
      }
    },
    async exitVisitor(id) {
      try {
        this.isLoadingVisitor = true;
        this.isNewVisitor = false;
        this.visitorCard = await this.getVisitorFromId(id);
        const response = await this.$axios
          .post("/Visitors/ExitVisitor?id=" + id)
          .then(response => {
            if (response.status == 200) {
              alertify.success(this.$ml.get("alerts.visitorSuccessfullyExit"));
              this.newVisitor();
              this.getVisitorCards(
                this.selectedGroupId,
                this.selectedGroupName
              );
            }
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoadingVisitor = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoadingVisitor = false;
                return;
              }
            }
          });
        this.isLoadingVisitor = false;
      } catch (error) {
        console.error(error);
        alertify.error("Hata :" + error.message);
        this.isLoadingVisitor = false;
      }
    },
    cancelEmployee() {
      this.visitor.employeeId = null;
      this.visitor.departmentId = null;
      this.visitor.visitTo = "";
      this.visitor.visitToSicil = "";
      this.employeeVisitor.sicilNo = "";
      this.employeeVisitor.name = "";
      this.employeeVisitor.lastStatus = "";
      this.employeeVisitor.lastMovementTime = "";
      this.employeeVisitor.lastMovementPoint = "";
      this.employeeVisitor.title = "";
      this.employeeVisitor.department = "";
      this.employeeVisitor.photo = "";
    },
    getDepartmentName(departmentId) {
      let department = this.departmentList.filter(function (item) {
        return item.id == departmentId;
      });
      if (department[0]) {
        return department[0].name;
      } else {
        return "";
      }
    },
    getDepartmentDetail(departmentId) {
      this.visitor.departmentId = departmentId;
    },
    async getEmployeeDetail(id, durum) {
      try {
        if (durum != 2) {
          this.isLoadingEmployee = true;
        }
        const response = await this.$axios
          .get("/Visitors/GetEmployeesWithStatus?id=" + id)
          .then(response => {
            if (response.status == 200) {
              if (durum == 1) {
                this.employee.name = response.data.name;
                this.employee.lastStatus = response.data.lastStatus;
                this.employee.lastMovementTime = response.data.lastMovementTime;
                this.employee.lastMovementPoint =
                  response.data.lastMovementPoint;
                this.employee.title = response.data.title;
                this.employee.department = response.data.department;
                this.employee.photo = response.data.photo;
                this.employee.state = response.data.state;
                this.employee.status = response.data.status;
              } else if (durum == 2) {
                this.visitor.employeeId = id;
                this.visitor.visitTo = response.data.name;
                this.visitor.visitToSicil = response.data.sicilNo;
                this.employeeVisitor.sicilNo = response.data.sicilNo;
                this.employeeVisitor.name = response.data.name;
                this.employeeVisitor.lastStatus = response.data.lastStatus;
                this.employeeVisitor.lastMovementTime =
                  response.data.lastMovementTime;
                this.employeeVisitor.lastMovementPoint =
                  response.data.lastMovementPoint;
                this.employeeVisitor.title = response.data.title;
                this.employeeVisitor.department = response.data.department;
                this.employeeVisitor.photo = response.data.photo;
              } else {
                this.waitingVisitor.employeeId = id;
                this.waitingVisitor.visitTo = response.data.name;
                this.waitingVisitor.visitToSicil = response.data.sicilNo;
                this.employeeVisitor.sicilNo = response.data.sicilNo;
                this.employeeVisitor.name = response.data.name;
                this.employeeVisitor.lastStatus = response.data.lastStatus;
                this.employeeVisitor.lastMovementTime =
                  response.data.lastMovementTime;
                this.employeeVisitor.lastMovementPoint =
                  response.data.lastMovementPoint;
                this.employeeVisitor.title = response.data.title;
                this.employeeVisitor.department = response.data.department;
                this.employeeVisitor.photo = response.data.photo;
              }
            }
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoadingEmployee = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoadingEmployee = false;
                return;
              }
            }
          });
        this.isLoadingEmployee = false;
      } catch (error) {
        console.error(error);
        alertify.error("Hata :" + error.message);
        this.isLoadingEmployee = false;
      }
    },
    async selectVisitor(id) {
      await this.newVisitor();
      this.visitorCard = await this.getVisitorFromId(id);
    },
    newVisitor() {
      this.isNewVisitor = true;
      this.visitor.id = null;
      this.visitor.name = "";
      this.visitor.identityNo = "";
      this.visitor.employeeId = null;
      this.visitor.departmentId = null;
      this.visitor.visitTo = "";
      this.visitor.visitToSicil = "";
      this.visitor.reason = "";
      this.visitor.entryDate = "";
      this.visitor.toWho = "";
      this.visitor.description = "";
      this.visitor.mobilePhone = "";
      this.visitor.isTemporaryCard = false;
      this.oldRecords = [];
      this.searchText2 = "";
      this.employeeVisitor.id = null;
      this.employeeVisitor.photo = null;
      this.employeeVisitor.sicilNo = "";
      this.employeeVisitor.name = "";
      this.employeeVisitor.lastStatus = null;
      this.employeeVisitor.lastMovementPoint = "";
      this.employeeVisitor.title = "";
      this.employeeVisitor.department = "";
    },
    async getVisitorCardDetails(id) {
      try {
        this.isLoadingVisitor = true;
        this.isNewVisitor = false;
        this.visitorCard = await this.getVisitorFromId(id);
        const response = await this.$axios
          .get("/Visitors/getVisitorCardDetails?id=" + id)
          .then(response => {
            if (response.status == 200) {
              this.visitor.id = response.data.id;
              this.visitor.name = response.data.name;
              this.visitor.identityNo = response.data.identityNo;
              this.visitor.employeeId = response.data.employeeId;
              this.visitor.departmentId = response.data.departmentId;
              this.visitor.visitTo = response.data.visitTo;
              this.visitor.visitToSicil = response.data.visitToSicil;
              this.visitor.reason = response.data.reason;
              this.visitor.entryDate = response.data.entryDate;
              this.visitor.toWho = response.data.toWho;
              this.visitor.description = response.data.description;
              this.visitor.mobilePhone = response.data.mobilePhone;
              this.getEmployeeDetail(response.data.employeeId, 2);
            }
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoadingVisitor = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoadingVisitor = false;
                return;
              }
            }
          });
        this.isLoadingVisitor = false;
      } catch (error) {
        console.error(error);
        alertify.error("Hata :" + error.message);
        this.isLoadingVisitor = false;
      }
    },
    async getWaitingVisitors() {
      try {
        this.isLoading = true;
        const waitingVisitors = [];
        const response = await this.$axios
          .get("/Visitors/GetWaitingVisitors")
          .then(response => {
            if (response.status == 200) {
              response.data.forEach(doc => {
                waitingVisitors.push({
                  id: doc.id,
                  name: doc.name,
                  visitTo: doc.visitTo,
                  visitToSicil: doc.visitToSicil,
                  reason: doc.reason,
                  date: doc.date,
                  description: doc.description,
                  employeeId: doc.employeeId,
                  identityNo: doc.identityNo
                });
              });
            }
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.waitingVisitors = waitingVisitors;
        this.isLoading = false;
      } catch (error) {
        console.error(error);
        alertify.error("Hata :" + error.message);
        this.isLoading = false;
      }
    },
    async getBlacklistVisitors() {
      try {
        this.isLoading = true;
        const blacklistVisitors = [];
        const response = await this.$axios
          .get("/Visitors/GetBlackList")
          .then(response => {
            if (response.status == 200) {
              response.data.forEach(doc => {
                blacklistVisitors.push({
                  id: doc.id,
                  identityNo: doc.identityNo,
                  name: doc.name,
                  description: doc.description
                });
              });
            }
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.blacklistVisitors = blacklistVisitors;
        this.isLoading = false;
      } catch (error) {
        console.error(error);
        alertify.error("Hata :" + error.message);
        this.isLoading = false;
      }
    },
    async getGelisNedenleri() {
      try {
        this.isLoading = true;
        const gelisNedenleri = [];
        const response = await this.$axios
          .get("/Visitors/GetReasons")
          .then(response => {
            if (response.status == 200) {
              response.data.forEach(doc => {
                gelisNedenleri.push({
                  id: doc.id,
                  name: doc.name
                });
              });
            }
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.gelisNedenleri = gelisNedenleri;
        this.isLoading = false;
      } catch (error) {
        console.error(error);
        alertify.error("Hata :" + error.message);
        this.isLoading = false;
      }
    },
    async getCardGroups() {
      try {
        this.isLoadingVisitor = true;
        const cardGroups = [];
        const response = await this.$axios
          .get("/Visitors/GetVisitorsCardGroup")
          .then(response => {
            if (response.status == 200) {
              response.data.forEach(doc => {
                cardGroups.push({
                  id: doc.id,
                  name: doc.name
                });
              });
            }
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoadingVisitor = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoadingVisitor = false;
                return;
              }
            }
          });
        this.cardGroups = cardGroups;
        var activeUser = this.$store.getters.getUser;
        try {
          if (activeUser.defaultVisitorCardGroup) {
            if (
              activeUser.defaultVisitorCardGroup != null &&
              activeUser.defaultVisitorCardGroup != 0
            ) {
              let groupId = activeUser.defaultVisitorCardGroup;
              let groupName = await this.getCardGroupNameFromId(groupId);
              await this.getVisitorCards(groupId, groupName);
            } else {
              ///this.selectedGroupName = "Grup Seçiniz";
              await this.getVisitorCards(0, this.$ml.get("general.all"));
            }
          } else {
            await this.getVisitorCards(0, this.$ml.get("general.all"));
          }
        } catch (error) {
          console.error(error);
        }
        this.isLoadingVisitor = false;
      } catch (error) {
        console.error(error);
        alertify.error("Hata :" + error.message);
        this.isLoadingVisitor = false;
      }
    },
    async getVisitorCards(cardGroupId, name) {
      try {
        this.isLoadingVisitor = true;
        this.selectedGroupName = name;
        this.selectedGroupId = cardGroupId;
        var visitorCards = [];
        const response = await this.$axios
          .get("/Visitors/GetVisitorCards?groupId=" + cardGroupId)
          .then(response => {
            if (response.status == 200) {
              response.data.forEach(doc => {
                visitorCards.push({
                  id: doc.id,
                  cardName: doc.cardName,
                  status: doc.status,
                  terminalNo: doc.terminalNo,
                  cardNo: doc.cardNo,
                  accessDoor: doc.accessDoor,
                  lastPerson: doc.lastPerson
                });
              });
            }
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoadingVisitor = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoadingVisitor = false;
                return;
              }
            }
          });
        this.visitorCards = visitorCards;
        this.isLoadingVisitor = false;
      } catch (error) {
        console.error(error);
        alertify.error("Hata :" + error.message);
        this.isLoadingVisitor = false;
      }
    },
    async getDepartments() {
      const departments = [];
      try {
        const response = await this.$axios
          .get("/Department")
          .then(response => {
            response.data.forEach(doc => {
              departments.push({
                id: doc.id,
                name: doc.name,
                mainDepartmentId: doc.mainDepartmentId,
                isActive: doc.isActive,
                locationTree: doc.locationTree,
                check: false
              });
            });
            departments.sort((a, b) => {
              if (a.locationTree < b.locationTree) return -1;
              if (a.locationTree > b.locationTree) return 0;
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.departments = departments;
        this.sortableTrees();
        this.isLoading = false;
      } catch (error) {
        console.error(error);
        alertify.error(error);
      }
    },
    sortableTrees() {
      this.sortableDepTrees = [];
      this.departments.forEach(dep => {
        if (dep.mainDepartmentId == null) {
          this.sortableDepTrees.push(dep);
          this.subDepImport(dep);
        }
      });
    },
    subDepImport(dep) {
      let subDep = this.departments.filter(function (doc) {
        return doc.mainDepartmentId == dep.id;
      });
      if (subDep.length > 0) {
        var ekle = "";
        let ek = subDep[0].locationTree.split("/");
        for (let index = 0; index < ek.length - 3; index++) {
          ekle = "--/" + ekle;
        }
        subDep.forEach(doc2 => {
          this.sortableDepTrees.push({
            id: doc2.id,
            name: ekle + " " + doc2.name,
            mainDepartmentId: doc2.mainDepartmentId,
            isActive: doc2.isActive,
            locationTree: doc2.locationTree,
            userId: doc2.userId,
            check: doc2.check
          });
          this.subDepImport(doc2);
        });
      }
    },
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  async created() {
    this.getCardGroups();
    this.getWaitingVisitors();
    this.getBlacklistVisitors();
    this.getGelisNedenleri();
    this.getDepartments();
    $("body").addClass("sidebar-collapse");
  }
};
</script>

<style scoped>
.tab-content .overlay>.fa,
.overlay-wrapper .overlay>.fa {
  position: absolute;
  top: 50%;
  left: 50%;
  margin-left: -15px;
  margin-top: -15px;
  color: #000;
  font-size: 30px;
}

.tab-content>.overlay,
.overlay-wrapper>.overlay,
.tab-content>.loading-img,
.overlay-wrapper>.loading-img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.tab-content .overlay {
  z-index: 50;
  background: rgba(255, 255, 255, 0.7);
  border-radius: 3px;
}

.nav-stacked>li>span {
  border-radius: 0;
  border-top: 0;
  border-left: 3px solid transparent;
  color: #444;
}

.nav>li>span {
  position: relative;
  display: block;
  padding: 10px 15px;
}
</style>



// WEBPACK FOOTER //
// src/pages/visitors/Visitors.vue